import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=4ea137c6&scoped=true"
import script from "./tag.vue?vue&type=script&lang=js"
export * from "./tag.vue?vue&type=script&lang=js"
import style0 from "./tag.vue?vue&type=style&index=0&id=4ea137c6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea137c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ea137c6')) {
      api.createRecord('4ea137c6', component.options)
    } else {
      api.reload('4ea137c6', component.options)
    }
    module.hot.accept("./tag.vue?vue&type=template&id=4ea137c6&scoped=true", function () {
      api.rerender('4ea137c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/healthManagement/tag.vue"
export default component.exports